export { default as buildGtmBannerEventData } from './buildGtmBannerEventData';